/**************************************************
 * Nombre:       Detalle_Barra_Busqueda
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import BarraBusqueda from "./SubComponentes/BarraBusqueda";

const Detalle_Barra_Busqueda = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 10, md: 11}} sx={{justifyContent: 'center'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 8}}
                    >

                        <BarraBusqueda/>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Detalle_Barra_Busqueda